import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SeoService } from './seo.service';


// lightgallery
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare let $: any;
declare var lightGallery: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit, AfterViewInit{

  constructor(
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private canonical: SeoService,
    private activatedRoute: ActivatedRoute
  ) { }

  updateDescription(desc: string, keywords: string, title: string) {
    this.titleService.setTitle(title);
    // console.log(title);
    this.meta.updateTag({ name: 'description', content: desc });
    this.meta.updateTag({ name: 'keywords', content: keywords });
   }
  title = 'ghrcacs';

  ngOnInit() { 

      this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
      while (route.firstChild) route = route.firstChild;
      return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
      )
      .subscribe((event) => {
      this.updateDescription(event['description'], event['keywords'], event['title']);
      });
      
      this.canonical.createCanonicalLink();

     
  }

  ngAfterViewInit(){
    setTimeout(()=>{
      /*---------------------------
      :: lightBox Gallery
      -----------------------------*/
      let galerias = document.getElementsByClassName('video-gallery');
       for (let i = 0; i < galerias.length; i++) {
         galerias[i].id = 'gal' + i; 
         lightGallery(document.getElementById('gal' + i), {
           selector: 'a',
         });
       } 
       
       let galImage = document.getElementsByClassName('lightgallery');

        for (const gal of galImage) {
          lightGallery(gal), {
            selector: 'a',
          }
        }
     }, 3000);  
  }
}
